import { put } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';

import { updateActiveChipAction } from 'core/widgets/ActiveChip/actions';
import { applyAutoConfirmAction } from 'core/widgets/GeneralSettings/actions';
import { updateGameIdAction } from 'core/widgets/TableSettings/actions';
import { saveWinnerToStoreAction } from 'core/widgets/Winner/actions';
import { Notifications } from 'types';
import { OnRoundStartedData } from '../types';
import { setTimeDifferenceUserServerToStoreAction } from 'core/widgets/BettingTime/actions';
import { clearAllBetsAction } from 'core/widgets/Bet/actions';
import { resetDrawResultToStoreAction } from 'core/widgets/DrawResult/actions';
import { setAvailableBetsAction } from 'core/widgets/Bet/BetAvailability';

export function* onRoundStartedSaga({ type: notificationType, data: result }: OnRoundStartedData) {
  if (notificationType === Notifications.ROUND_STARTED) {
    const {
      round: { roundId, startedAt },
      availableBets,
    } = result;

    const date = new Date(startedAt);
    const dateNow = new Date();
    const difference = Math.floor((date.getTime() - dateNow.getTime()) / 1000);

    yield put(setTimeDifferenceUserServerToStoreAction(difference));

    yield put(setAvailableBetsAction(availableBets));
    yield put(clearAllBetsAction());
    yield put(updateGameIdAction({ gameId: roundId }));
    yield put(saveWinnerToStoreAction({ winner: null }));
    yield put(resetDrawResultToStoreAction());
    yield put(updateActiveChipAction());
    yield put(applyAutoConfirmAction());
    Sentry.setTag('game_id', roundId);
  }
}
